




























import {checkIsDisabled, checkIsWeekend, Formatter} from "@goodless/utilities"
import { NavigationMixin } from "@simonbackx/vue-app-navigation";
import { Component, Mixins,Prop } from "vue-property-decorator";
import ContextMenu from "../layout/ContextMenu.vue";

@Component({
    components: {
        ContextMenu
    },
})
export default class DateSelectionView extends Mixins(NavigationMixin) {
    @Prop({ default: 0 })
    x!: number;

    @Prop({ default: 0 })
    y!: number;

    @Prop({ default: null })
    minDate!: Date | null

    @Prop({ default: null })
    maxDate: Date | null

    @Prop()
    setDate!: (date: Date) => void;

    @Prop({ default: null })
    selectedDay!: Date | null
    currentMonth: Date = new Date((this.selectedDay ?? this.minDate ?? new Date()).getTime())
    weeks: any = null
    monthTitle = ""

    created() {
        this.weeks = this.generateDays()
        this.updateMonthTitle()
    }

    generateDays() {
        const weeks: any = [];

        const start = new Date(this.currentMonth.getTime())
        start.setDate(1)

        const month = start.getMonth()
        const year = start.getFullYear()

        // Make sure first day is 1
        while (start.getDay() != 1) {
            start.setDate(start.getDate() - 1)
        }

        // loop days
        while ((start.getMonth() <= month && start.getFullYear() == year) || start.getFullYear() < year || start.getDay() != 1) {
            if (start.getDay() == 1) {
                // Start new week
                weeks.push([])
            }

            weeks[weeks.length - 1].push({
                number: start.getDate(),
                value: new Date(start.getTime()),
                otherMonth: start.getMonth() != month,
                selected: this.selectedDay && start.getDate() == this.selectedDay.getDate() && start.getFullYear() == this.selectedDay.getFullYear() && start.getMonth() == this.selectedDay.getMonth()
            })

            start.setDate(start.getDate() + 1)

            if (weeks[weeks.length - 1].length > 7 || weeks.length > 6) {
                console.error("Calendar infinite loop")
                break;
            }
        }
        return weeks
    }

    isDateDisabled(date: Date) {
        const returnedObject =  checkIsDisabled(date)
        return returnedObject.disabled
    }

    checkIfWeekend(date: Date): boolean {
        return checkIsWeekend(date)
    }

    updateMonthTitle() {
        this.monthTitle = Formatter.capitalizeFirstLetter(Formatter.month(this.currentMonth.getMonth() + 1))
        if (this.currentMonth.getFullYear() != new Date().getFullYear()) {
            this.monthTitle += " "+this.currentMonth.getFullYear()
        }
    }

    nextMonth() {
        this.currentMonth.setDate(1)
        this.currentMonth.setMonth(this.currentMonth.getMonth() + 1)
        this.updateMonthTitle();
        this.weeks = this.generateDays()
    }

    previousMonth() {
        this.currentMonth.setDate(0)
        this.currentMonth.setDate(1)
        this.updateMonthTitle();
        this.weeks = this.generateDays()
    }

    onSelect(day) {
        day.selected = true;
        this.setDate(day.value)
        this.pop();
    }

}
